<template>
  <div class="relative w-full">
    <div class="relative">
      <NavBar />
      <div class="h-screen w-full overflow-auto relative flex pt-[var(--height-header)] flex-col">
        <div class="flex-grow overflow-auto app-scrollbar dark:bg-black" ref="appScrollbar">
          <div class="min-h-full">
            <slot></slot>
          </div>
          <Footer></Footer>
        </div>
      </div>
    </div>
    <!-- 右下角功能提示帮助 -->
    <PageHelp></PageHelp>
  </div>
</template>

<script lang="ts" setup>
import NavBar from './NavBar.vue';
import Footer from './Footer.vue';
import PageHelp from '~/components/PageHelp.vue';
import { nextTick, ref, watch } from 'vue';
const appScrollbar = ref<HTMLElement | null>(null);
const router = useRouter();
watch(
  () => router.currentRoute.value,
  (_newValue: any) => {
    nextTick(() => {
      appScrollbar.value?.scrollTo(0, 0);
    });
  },
  { immediate: true },
);
</script>

<style scoped lang="scss">
/** 美化原生滚动条 */
.app-scrollbar {
  // 整个滚动条
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  // 滚动条上的滚动滑块
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #90939955;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #90939977;
  }

  &::-webkit-scrollbar-thumb:active {
    background-color: #90939999;
  }

  // 当同时有垂直滚动条和水平滚动条时交汇的部分
  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
}
</style>
